/* ==========================================================================
   HuggingMum — product page behaviour: gallery and variant selection
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* --- <product-gallery> -------------------------------------------------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this);
      this.thumbs = $$('[data-gallery-thumb]', this);
      this.counter = $('[data-gallery-counter]', this);
      this.index = 0;
      if (this.slides.length < 2) return;

      const prev = $('[data-gallery-prev]', this);
      const next = $('[data-gallery-next]', this);
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryThumb)));
      });

      // swipe
      let startX = null;
      const stage = $('.gallery__stage', this);
      stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    go(next) {
      const total = this.slides.length;
      const i = ((next % total) + total) % total;
      this.slides.forEach((slide, n) => {
        slide.hidden = n !== i;
        slide.classList.toggle('is-active', n === i);
      });
      this.thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === i));
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + total;
      this.index = i;
    }

    /* called by the variant picker when a variant carries its own image */
    showMedia(mediaId) {
      const target = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (target > -1) this.go(target);
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* --- <variant-picker> --------------------------------------------------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = $('[data-variant-data]', this);
      if (!data) return;
      try { this.variants = JSON.parse(data.textContent); } catch (e) { return; }

      this.selected = [];
      $$('.vpick__group', this).forEach((group, i) => {
        const active = $('[aria-pressed="true"]', group);
        this.selected[i] = active ? active.dataset.optionValue : null;
      });

      $$('[data-option-value]', this).forEach((button) => {
        button.addEventListener('click', () => this.choose(button));
      });
    }

    choose(button) {
      const group = button.closest('.vpick__group');
      const index = Number(group.dataset.optionIndex);
      $$('[data-option-value]', group).forEach((other) => {
        other.setAttribute('aria-pressed', String(other === button));
      });
      const label = $('[data-selected-value]', group);
      if (label) label.textContent = button.dataset.optionValue;
      this.selected[index] = button.dataset.optionValue;
      this.apply();
    }

    apply() {
      const match = this.variants.find((variant) =>
        variant.options.every((value, i) => value === this.selected[i])
      );

      const idField = $('[data-variant-id]');
      const atc = $('[data-atc]');
      const price = $('[data-product-price]');
      const stickyMeta = $('[data-sticky-meta]');

      if (!match) {
        if (atc) { atc.disabled = true; atc.textContent = window.HM.strings.unavailable; }
        return;
      }

      if (idField) idField.value = match.id;

      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      if (price) {
        const now = $('.price__now', price);
        const was = $('.price__was', price);
        if (now) now.textContent = window.HM.formatMoney(match.price);
        if (was) {
          if (match.compare_at_price > match.price) {
            was.textContent = window.HM.formatMoney(match.compare_at_price);
            was.hidden = false;
          } else {
            was.hidden = true;
          }
        }
      }

      if (atc) {
        atc.disabled = !match.available;
        if (!match.available) {
          atc.textContent = window.HM.strings.soldOut;
        } else {
          atc.innerHTML = window.HM.strings.addToCart + ' &mdash; <span class="num" data-atc-price>' +
            window.HM.formatMoney(match.price) + '</span>';
        }
      }

      if (stickyMeta) stickyMeta.textContent = this.selected.filter(Boolean).join(' · ');

      const gallery = $('product-gallery');
      if (gallery && match.featured_media && gallery.showMedia) {
        gallery.showMedia(match.featured_media.id);
      }
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* --- product recommendations ------------------------------------------- */
  const recs = $('[data-recommendations]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const fresh = $('.related', parsed);
        if (fresh) recs.replaceWith(fresh);
      })
      .catch(() => { recs.remove(); });
  }
})();
